module.exports = __webpack_public_path__ + "static/media/confirm.fa174c71.svg";